<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSettings.posts.title") }}</h3>
    <v-card class="mt-2" elevation="0">
      <v-flex xs12 lg6>
        <v-form ref="postForm">
          <v-text-field
            outlined
            v-if="fetched || !!this.$route.params.id"
            :rules="[
              (v) => !!v || $t('form.validationErrors.field_is_required'),
            ]"
            :value="currentPost.name"
            v-model="currentPost.name"
            :label="$t('common.title')"
          ></v-text-field>
          <v-select
              :loading="!isFetchedIcons"
              clearable
              :disabled="!isFetchedIcons"
              outlined
              xs6
              hide-details
              :items="icons"
              item-text="id"
              :label="$t('common.picture')"
              return-object
              v-model="currentPost.post_icon"
          >
            <template v-slot:selection="{ item }">
              <img height="20" :src="postIconPath+item.file"/>
            </template>
            <template v-slot:item="{ item }">
              <img :src="postIconPath+item.file"/>
            </template>
          </v-select>
          <v-checkbox
            :value="1"
            v-if="fetched || !!this.$route.params.id"
            v-model="currentPost.active"
            :label="$t('viewSettings.posts.active_blocked')"
            hide-details
            class="mb-5 mt-0"
          ></v-checkbox>
          <v-checkbox
            :value="1"
            v-if="fetched || !!this.$route.params.id"
            v-model="currentPost.can_auth"
            :label="$t('viewSettings.posts.can_auth')"
            hide-details
            class="mb-5 mt-0"
          ></v-checkbox>
          <div v-if="currentPost.can_auth">
            <v-text-field
              outlined
              v-if="fetched || !!this.$route.params.id"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              :value="currentPost.login"
              v-model="currentPost.login"
              :label="$t('common.login')"
              :hide-details="!!parseInt($route.params.id)"
            ></v-text-field>

            <v-switch
              v-if="!!parseInt($route.params.id)"
              color="primary"
              v-model="changePassword"
              :label="$t('common.change_password')"
            ></v-switch>
            <v-text-field
              class="mt-0"
              v-if="changePassword"
              v-model="currentPost.password"
              :label="$t('common.password')"
              :append-icon="
                currentPost.password === currentPost.password_confirmation
                  ? 'fa-lock'
                  : 'fa-lock-open'
              "
              required
              outlined
              type="password"
            ></v-text-field>
            <v-text-field
              v-if="changePassword"
              v-model="currentPost.password_confirmation"
              :label="$t('common.password_confirmation')"
              :append-icon="
                currentPost.password === currentPost.password_confirmation
                  ? 'fa-lock'
                  : 'fa-lock-open'
              "
              required
              outlined
              type="password"
            ></v-text-field>
            <v-list>
              <v-subheader>
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="16"
                  v-if="!isFetchedUsers"
                />
                <strong
                  >{{ $t("viewSettings.posts.mechanics") }}:</strong
                ></v-subheader
              >
              <v-list-item
                @click="toggleUser(user)"
                class="pointer"
                v-for="user in users"
              >
                <v-list-item-action>
                  <v-simple-checkbox
                    class="d-flex"
                    @input="toggleUser(user)"
                    :value="
                      !!currentPost.users.find(
                        (item) => parseInt(item.id) === parseInt(user.id)
                      )
                    "
                    hide-details
                  ></v-simple-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ user.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <v-divider></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="savingInProgress"
            :loading="savingInProgress"
            class="mt-5 white--text mr-4"
            elevation="0"
            color="red"
            @click="$router.push({ name: 'settings-posts' })"
            @keyup.enter="$router.push({ name: 'settings-posts' })"
          >
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            :disabled="savingInProgress"
            :loading="savingInProgress"
            class="mt-5"
            elevation="0"
            color="primary"
            @click="submit"
            @keyup.enter="submit"
          >
            {{ $t("common.save") }}
          </v-btn>
        </v-form>
      </v-flex>
    </v-card>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
export default {
  name: "PostForm",
  mixins:[CommonMixin],
  //currentPost.name
  data: () => ({
    changePassword: false,
    currentPost: {
      name: "",
      active: 1,
      can_auth: 0,
      login: null,
      users: [],
    },
  }),
  created() {
    this.onLoad();
  },

  watch: {
    $route(to, from) {
      this.onLoad();
    },
  },
  computed: {
    ...mapFields("posts", [
      "posts",
      "fetched",
      "savingInProgress",
      "icons",
      "isFetchedIcons",
    ]),
    ...mapFields("users", ["users"]),
    ...mapFields("users", { isFetchedUsers: "fetched" }),
  },
  methods: {
    toggleUser(user) {
      if (
        this.currentPost.users.find(
          (item) => parseInt(item.id) === parseInt(user.id)
        )
      ) {
        this.currentPost.users.splice(
          this.currentPost.users.findIndex(
            (o) => parseInt(o.id) === parseInt(user.id)
          ),
          1
        );
      } else {
        this.currentPost.users.push(user);
      }
    },
    onLoad() {
      this.$store.dispatch("users/get");
      this.$store.dispatch("posts/getIcons");
      if (this.$route.params.id > 0) {
        this.$store.dispatch("posts/get").then(() => {
          let item = this.posts.filter(
            (item) => Number(item.id) === Number(this.$route.params.id)
          );
          if (!item) {
            this.$router.push({ name: "404" });
          } else {
            this.currentPost = Object.assign(this.currentPost, item[0]);
          }
        });
      } else {
        this.changePassword = true;
      }
    },
    submit() {
      if (this.$refs["postForm"].validate()) {
        if (!this.currentPost.can_auth) {
          delete this.currentPost["login"];
        }
        if (this.$route.params.id > 0) {
          this.$store.dispatch("posts/update", this.currentPost).then((id) => {
            if (id > 0) {
              this.$store.dispatch("posts/get");
              this.$router.push({ name: "settings-posts" });
            }
          });
        } else {
          this.$store.dispatch("posts/store", this.currentPost).then((id) => {
            if (id > 0) {
              this.$store.dispatch("posts/get");
              this.$router.push({ name: "settings-posts" });
            }
          });
        }
      }
    },
  },
};
</script>

<style scoped></style>
